import React from "react";
import { HashLink } from "react-router-hash-link";
import ArrowNe from "../ArrowNe.js";
import "./banner.scss";

const Banner = () => {
  return (
    <section className="mz-hero">
      <div className="mz-hero__globe">
        <img src="/assets/figma/globe.png?v=3" srcSet="/assets/figma/globe.png?v=3 2x" width="730" height="290" alt="" />
      </div>
      <div className="mz-hero__copy">
        <div className="mz-hero__text">
          <h1 className="mz-hero__title">The best way to predict the future is to invent it.</h1>
          <p className="mz-hero__sub">
            A product engineering studio. We design, build, and ship web, mobile, and AI products, from first idea to production.
          </p>
        </div>
        <div className="mz-hero__ctas">
          <HashLink className="mz-hero__btn mz-hero__btn--primary" to="/#contact">
            Start a project
          </HashLink>
          <HashLink className="mz-hero__btn mz-hero__btn--ghost" to="/#product">
            Meet Joni
            <ArrowNe />
          </HashLink>
        </div>
      </div>
    </section>
  );
};

export default Banner;
